import MetricInput from './MetricInput';

export default MetricInput;
